import { defineMessages } from 'react-intl';

export const customersMessages = defineMessages({
    customers: {
        id: 'customers',
        defaultMessage: 'Customers',
    },
    customersTableCount: {
        id: 'customers-table-count',
        defaultMessage: 'Customers',
    },
    customer: {
        id: 'customer',
        defaultMessage: 'Customer',
    },
    externalCustomerId: {
        id: 'external-customer-id',
        defaultMessage: 'External customer ID',
    },
    stripeCustomerId: {
        id: 'stripe-customer-id',
        defaultMessage: 'Stripe customer ID',
    },
    createCustomerSuccess: {
        id: 'create-customer-success',
        defaultMessage: 'Customer created',
    },
    createCustomerSuccessDescription: {
        id: 'create-customer-success-description',
        defaultMessage: 'Customer {entry} has been successfully created.',
    },
    addCustomerSubtitle: {
        id: 'add-customer-subtitle',
        defaultMessage: 'Create a new customer',
    },
    deleteCustomer: {
        id: 'delete-customer',
        defaultMessage: 'Delete customer',
    },
    deleteCustomerSuccess: {
        id: 'delete-customer-success',
        defaultMessage: 'Customer deleted',
    },
    deleteCustomerSuccessDescription: {
        id: 'delete-customer-success-description',
        defaultMessage: 'The customer has been successfully deleted.',
    },
    confirmDeleteCustomer: {
        id: 'confirm-delete-customer',
        defaultMessage: 'Are you sure you want to delete this customer? This action cannot be undone.',
    },
    deleteCustomerSubtitle: {
        id: 'delete-customer-subtitle',
        defaultMessage: 'Permanently delete customer {entity}',
    },
    editCustomerSubtitle: {
        id: 'edit-customer-subtitle',
        defaultMessage: 'Edit customer {entity}',
    },
    updateCustomerSuccess: {
        id: 'update-customer-success',
        defaultMessage: 'Customer updated',
    },
    updateCustomerSuccessDescription: {
        id: 'update-customer-success-description',
        defaultMessage: 'Customer {entity} has been successfully updated.',
    },
    customerDashboard: {
        id: 'customer-dashboard',
        defaultMessage: 'Customer dashboard',
    },
    paymentProvider: {
        id: 'payment-provider',
        defaultMessage: 'Payment provider',
    },
    paymentProviderType: {
        id: 'payment-provider-type',
        defaultMessage: 'Payment provider type',
    },
    paymentProviderCustomerId: {
        id: 'payment-provider-customer-id',
        defaultMessage: 'Payment provider customer ID',
    },
    gracePeriod: {
        id: 'grace-period',
        defaultMessage: 'Grace period',
    },
    backToAllCustomers: {
        id: 'back-to-all-customers',
        defaultMessage: 'Back to all customers',
    },
    manual: {
        id: 'manual',
        defaultMessage: 'Manual',
    },
    automatic: {
        id: 'automatic',
        defaultMessage: 'Automatic',
    },
    invoiceGracePeriodDays: {
        id: 'invoice-grace-period-days',
        defaultMessage: 'Invoice grace period days',
    },
    searchCustomer: {
        id: 'search-customer',
        defaultMessage: 'Search customer',
    },
    noCustomer: {
        id: 'no-customer',
        defaultMessage: 'No customer',
    },
    noCustomerFound: {
        id: 'no-customer-found',
        defaultMessage: 'No customer found',
    },
});
